import { NgModule } from '@angular/core';
import { LibCircleIconComponent } from './lib-circle-icon.component';

@NgModule({
  declarations: [LibCircleIconComponent],
  exports: [LibCircleIconComponent],
})
export class LibCircleIconModule {}
